// removed by extract-text-webpack-plugin
module.exports = {"ipad-portrait":"768px","mobile":"480px","imagePlaceholder":"_2bg6SK9AEXF21gLG2xYofW","rightSide":"_3v1SovnVHCiC2ay6mRnmNL"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/OthersBanner/common/ImgPlaceholder/ImagePlaceholder.css
// module id = 1407
// module chunks = 0